import { Box,Collapse,IconButton } from '@mui/material';
import Alert from '@mui/material/Alert';
import React,{ useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IoCloseCircleOutline,IoWarning } from 'react-icons/io5';
import { UserContext } from '../../context/UserContext';
import callAssociateAll from '../../helpers/callAssociateAll';
import { trackEventMatomo } from '../../helpers/matomo';
import { StyledStrong,StyledWarningDiv } from './Style';

export default function ChangeAlert() {
  const { t } = useTranslation('translation');
  const [open, setOpen] = React.useState(true);
  const { setChanged } = useContext(UserContext);

  return open ? (
    <div style={{ position: 'absolute', zIndex: 100, width: '80%', top: '3em', right: '4em'}}>
      <Box sx={{ width: '100%' }}>
        <Collapse in={open}>
          <Alert
            severity='warning'
            variant="filled"
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  trackEventMatomo('alerta de alterações', 'click', 'botão', 'fecha alerta');
                  setOpen(false);
                }}
              >
                <IoCloseCircleOutline fontSize="inherit" />
              </IconButton>
            }
          >
            <span>
              {t('ChangeAlert.changes')}
            </span>
            <StyledStrong onClick={() => {
              setChanged(false);
              callAssociateAll();
            }}> {t('notifications.all.clickHere')} </StyledStrong>
            <span>
              {t('ChangeAlert.changesEnd')}
            </span>
          </Alert>
        </Collapse>
      </Box>
    </div>
  ) : (
    <StyledWarningDiv onClick={() => {
      trackEventMatomo('alerta de alterações', 'click', 'ícone', 'reabre alerta');
      setOpen(true);
    }}>
      <IoWarning size={40} style={{ alignSelf: 'center' }}/>
    </StyledWarningDiv>
  );
}
